  import { lazy } from "react";
  import routes from "./routesConfig/index";
  
  const ProcessingPage = lazy(() => import("../ProcessingPage/ProcessingPage"));
  const ProcessingDetails = lazy(() => import("../ProcessingPage/processing-detail/ProcessingDetail"));
  const ProcessingNewForms = lazy(() => import("../ProcessingPage/processing-new-forms/ProcessingNewForms"));
  const ProcessingDocuments = lazy(() => import("../ProcessingPage/processing-documents/ProcessingDocuments"));
  
  const processingRoutes = [
    { path: routes.processings, component: ProcessingPage, moduleKey: "processing", permissionKey: "processing_global_list" },
    { path: routes.processingDetails, component: ProcessingDetails, moduleKey: "processing", permissionKey: "processing_global_list" },
    { path: routes.processingDocuments, component: ProcessingDocuments, moduleKey: "processing", permissionKey: "processing_global_list" },
    { path: routes.processingNewForms, component: ProcessingNewForms, moduleKey: "processing", permissionKey: "processing_global_list" },
  ];
  
  export default processingRoutes;

